<mat-accordion class="gsm-overview_filter-expansion">
  <mat-expansion-panel>
    <mat-expansion-panel-header expandedHeight="40px" collapsedHeight="40px">
      Filter&nbsp;
      <mat-icon class="mat-24">filter_list</mat-icon>
    </mat-expansion-panel-header>
    <gsm-overview-filter-schaden
      (globalFilterEmitter)="applyGlobalFilter($event)"
      (filter)="applyFilter($event)"
      [isKbma]="isKbma"
      [isReset]="reset"
      [isARGE]="isARGE"
      [isSchadenTab]="isSchadenTab"
    ></gsm-overview-filter-schaden>
  </mat-expansion-panel>
</mat-accordion>
<div class="gsm-overview_container">
  <mat-card class="gsm-overview_toolbar-card">
    <div *ngIf="schwebebestand" class="gsm-overview_existing-process-container">
      <div class="gsm-overview_existing-process_content">
        <div class="gsm-overview_existing-process_content_warning-block">
          <mat-icon class="gsm-overview_existing-process_content_icon">warning</mat-icon>
          <div class="gsm-overview_existing-process_content_warning-text">
            Achtung, Ihre letzte Schadenmeldung wurde nicht abgeschlossen! Sollten Sie die Schadenmeldung weiter
            bearbeiten wollen, können
            sie dies über den Bearbeiten-Button tun. Andernfalls können sie den Entwurf über den Löschen-Button
            verwerfen.
          </div>
        </div>
        <div class="gsm-overview_existing-process_content_warning-schwebebestand" *ngIf="schwebebestand">
          <p class="gsm-overview_existing-process_metadata">
            <span
              *ngIf="schwebebestand.polizzeNummer">{{ schwebebestand.polizzeNummer | formatNumber: 'polizze' }}</span
            >{{ metaDataString ? metaDataString : 'GSM-Daten konnten nicht geladen werden' }}
          </p>
          <div class="gsm-overview_existing-process_buttons">
            <button mat-icon-button type="button" (click)="selectItem($event, this.schwebebestand)">
              <mat-icon>create</mat-icon>
            </button>
            <button mat-icon-button type="button" (click)="deleteItem($event, this.schwebebestand)">
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        </div>
      </div>
    </div>
    <button mat-raised-button class="button-top-left" color="primary" (click)="schadenMelden.emit()">
      Schaden melden
    </button>
    <mat-checkbox class="gsm-overview_arge-checkbox" id="checkbox-1" (change)="onArgeCheckboxChange($event)"
                  [checked]="isARGE">
      <!--Show label "alle Schäden der Vertriebseinheit" if user role is Vertriebseinheit(=Kundenbüromitarbeiter)-->
      {{ getCheckboxLabel() }}
    </mat-checkbox>
    <button
      *ngIf="!isSchadenTab && !isARGE && schadenEntwurf?.length > 0"
      class="gsm-overview_entwuerfe-delete-btn"
      mat-button
      matTooltip="Alle Entwürfe löschen"
      [disabled]="entwurfOverviewIsLoading"
      (click)="deleteAllDrafts($event)"
    >
      <div class="delete-draft-button">
        <mat-icon>delete</mat-icon>
        Alle Entwürfe löschen
      </div>
    </button>
  </mat-card>
  <mat-tab-group (selectedTabChange)="onTabChange()">
    <mat-tab label="Schäden ({{ !schadenOverviewIsLoading ? schadenUebersicht?.length || 0 : 0 }})">
      <ng-template matTabContent>
        <!--        Spinner-->
        <div class="gsm-overview_spinner" *ngIf="schadenOverviewIsLoading">
          <mat-spinner></mat-spinner>
        </div>
        <div class="gsm-form-error" *ngIf="!schadenOverviewIsLoading && schadenUebersicht?.length <= 0"
             data-test="gsm-form_error">
          <p>Keine Einträge vorhanden.</p>
        </div>

        <table
          mat-table
          [dataSource]="schadenUebersichtDataSource"
          *ngIf="!schadenOverviewIsLoading && schadenUebersicht?.length > 0"
          class="mat-elevation-z8"
          multiTemplateDataRows
          matSort
          matSortDisableClear
        >
          <!-- Schaden-Nr. Column -->
          <ng-container matColumnDef="schadenNummer">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Schadennummer</th>
            <td mat-cell *matCellDef="let element">
              {{ element.schadenNummer | formatNumber: 'schaden' }}
            </td>
          </ng-container>

          <!-- Datum Column -->
          <ng-container matColumnDef="schadenDatum">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Schadendatum</th>
            <td mat-cell *matCellDef="let element">
              {{ element.schadenDatum | amDateFormat: 'DD.MM.YYYY' }}
            </td>
          </ng-container>

          <!-- Meldedatum -->
          <ng-container matColumnDef="meldeDatum">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Meldedatum</th>
            <td mat-cell *matCellDef="let element">
              {{ element.meldeDatum | amDateFormat: 'DD.MM.YYYY' }}
            </td>
          </ng-container>

          <!-- Vertragssparte Column -->
          <ng-container matColumnDef="vertragsSparte">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Vertragssparte</th>
            <td mat-cell *matCellDef="let element">
              {{ element.vertragsSparte }}
            </td>
          </ng-container>

          <!-- Kundenname Column -->
          <ng-container matColumnDef="kundeNachname">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Kundenname</th>
            <td mat-cell *matCellDef="let element">{{ element.kundeNachname }} {{ element.kundeVorname }}</td>
          </ng-container>

          <!-- Status Column -->
          <ng-container matColumnDef="schadenStatus">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
            <td mat-cell *matCellDef="let element">
              <div class="mat-column-schadenStatus_data-content">
                <mat-icon
                  [ngClass]="{
                    'status-red': element.schadenStatus === 'Angelegt',
                    'status-green': element.schadenStatus === 'Erledigt',
                    'status-orange': element.schadenStatus === 'Gemeldet'
                  }"
                >
                  brightness_1
                </mat-icon>
                <p>{{ element.schadenStatus }}</p>
              </div>
            </td>
          </ng-container>

          <!-- Checklist Item Column -->
          <ng-container matColumnDef="checkListStatus">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Checkliste</th>
            <td mat-cell *matCellDef="let element">
              <p>{{ element.checkListStatus ? convertToCheckListStatusText(element.checkListStatus) : 'Unbekannt' }}</p>
            </td>
          </ng-container>

          <!-- Aktionen Column -->
          <ng-container matColumnDef="aktionen">
            <th mat-header-cell *matHeaderCellDef>Aktionen</th>
            <td mat-cell *matCellDef="let element">
              <button mat-icon-button matTooltip="Checkliste bearbeiten" (click)="selectItem($event, element)">
                <mat-icon>create</mat-icon>
              </button>
              <button mat-icon-button matTooltip="Im NV Cockpit öffnen" (click)="printItem($event, element)">
                <mat-icon>developer_board</mat-icon>
              </button>
              <!--TODO disabled condition to be delivered by backend-->
              <button
                mat-icon-button
                matTooltip="Unterschriftenprozess aufrufen"
                disabled="{{ element.checkListStatus === 'K' }}"
                (click)="openEsignDialog($event, element)"
                class="sign-button"
              >
                <mat-icon>create</mat-icon>
              </button>
            </td>
          </ng-container>

          <!-- Erinnerung Column -->
          <ng-container matColumnDef="gsmNotificationEnabled">
            <th mat-header-cell *matHeaderCellDef>Erinnerung</th>
            <td mat-cell *matCellDef="let element">
              <button
                mat-icon-button
                *ngIf="element.schadenStatus !== 'Erledigt' && element.checkListStatus !== 'K' && element.checklistItemList.length !== 0"
                matTooltip="Erinnerung"
                (click)="handleGsmNotificationToggle($event, element)"
              >
                <mat-icon *ngIf="element.gsmNotificationEnabled; else elseBlock">notifications_active</mat-icon>
                <ng-template #elseBlock>
                  <mat-icon>notifications_off</mat-icon>
                </ng-template>
              </button>
            </td>
          </ng-container>

          <!-- IconToggle Column -->
          <ng-container matColumnDef="iconToggle">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let element">
              <button mat-icon-button>
                <mat-icon *ngIf="element !== expandedElement">keyboard_arrow_down</mat-icon>
                <mat-icon *ngIf="element === expandedElement">keyboard_arrow_up</mat-icon>
              </button>
            </td>
          </ng-container>

          <!-- Checklist Detail -->
          <ng-container matColumnDef="checklistDetail">
            <td mat-cell *matCellDef="let element" [attr.colspan]="displayedColumnsSchaden.length">
              <div class="element-detail" [@detailExpand]="element === expandedElement ? 'expanded' : 'collapsed'">
                <div class="element-description">
                  <div class="element-detail-row">
                    <div class="element-detail-cell">
                      <p>Polizzenadresse:</p>
                    </div>
                    <div class="element-detail-cell">
                      <p>
                        {{ element.polizzenadresse }}
                      </p>
                    </div>
                  </div>
                  <div class="element-detail-row">
                    <div class="element-detail-cell">
                      <p>Betreuernummer:</p>
                    </div>
                    <div class="element-detail-cell">
                      <p>
                        {{ element.betreuerNummer }}
                      </p>
                    </div>
                  </div>
                  <div class="element-detail-row">
                    <div class="element-detail-cell">
                      <p>Referent:</p>
                    </div>
                    <div class="element-detail-cell">
                      <p>
                        {{ element.referent }}
                      </p>
                    </div>
                  </div>
                  <div class="element-detail-row">
                    <div class="element-detail-cell">
                      <p>zuletzt bearbeitet von:</p>
                    </div>
                    <div class="element-detail-cell">
                      <p>{{ element.letzterBearbeiterVorname }} {{ element.letzterBearbeiterNachname }}</p>
                    </div>
                  </div>
                  <div class="element-detail-row">
                    <div class="element-detail-cell">
                      <p>zuletzt bearbeitet am:</p>
                    </div>
                    <div class="element-detail-cell">
                      <p>
                        {{ element.letzteBearbeitungDatum | amDateFormat: 'DD.MM.YYYY' }}
                      </p>
                    </div>
                  </div>
                  <div *ngIf="element.schadenUrsache" class="element-detail-row">
                    <div class="element-detail-cell">
                      <p>Schadenursache:</p>
                    </div>
                    <div class="element-detail-cell">
                      <p>
                        {{ element.schadenUrsache }}
                      </p>
                    </div>
                  </div>
                  <div *ngIf="element.kfzKennzeichen" class="element-detail-row">
                    <div class="element-detail-cell">
                      <p>KFZ Kennzeichen:</p>
                    </div>
                    <div class="element-detail-cell">
                      <p>
                        {{ element.kfzKennzeichen }}
                      </p>
                    </div>
                  </div>
                  <div class="element-detail-row">
                    <div class="element-detail-cell">
                      <p>Zahlungen:</p>
                    </div>
                    <div class="element-detail-cell">
                      <p>€ {{ element.gesamtZahlung | number: '1.2-2':'de-DE' }}</p>
                    </div>
                  </div>
                  <div class="element-detail-row" *ngIf="element.checklistItemList.length">
                    <div class="element-detail-cell">
                      <p>Checklisteneinträge:</p>
                    </div>
                    <div class="element-detail-cell">
                      <p *ngFor="let item of element.checklistItemList; let isLast = last">
                        {{ item.def?.label }}
                        <span
                          *ngIf="item.status"> - {{ getCheckListItemStatus(item.status) }}</span
                        ><span *ngIf="item.grund"> - {{ item.grund }}</span
                      >{{ isLast ? '' : ', ' }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumnsSchaden"></tr>
          <tr
            mat-row
            *matRowDef="let row; columns: displayedColumnsSchaden"
            class="element-row"
            [ngClass]="{ 'highlight-row': getTrimmedSchadennummer(row.schadenNummer) === highlightedSchadenNummer }"
            [class.expanded-row]="expandedElement === row"
            (click)="toggleRowExpand(row)"
          ></tr>
          <tr mat-row *matRowDef="let element; columns: ['checklistDetail']" class="checklist-detail-row"></tr>
        </table>

        <div [hidden]="schadenUebersichtDataSource.data.length <= 10 || schadenOverviewIsLoading">
          <mat-paginator #paginatorSchaden [pageSizeOptions]="[10, 50, 100]"></mat-paginator>
        </div>
      </ng-template>
    </mat-tab>
    <mat-tab label="Entwurf ({{ !entwurfOverviewIsLoading ? schadenEntwurf?.length || 0 : 0 }})">
      <ng-template matTabContent>
        <!--        Spinner-->
        <div class="gsm-overview_spinner" *ngIf="entwurfOverviewIsLoading">
          <mat-spinner></mat-spinner>
        </div>
        <div class="gsm-form-error" *ngIf="!entwurfOverviewIsLoading && schadenEntwurf?.length <= 0"
             data-test="gsm-form_error">
          <p>Keine Einträge vorhanden.</p>
        </div>
        <table
          mat-table
          [dataSource]="schadenEntwurfDataSource"
          *ngIf="!entwurfOverviewIsLoading && schadenEntwurf?.length > 0"
          multiTemplateDataRows
          matSort
          matSortActive="letzteBearbeitungDatum"
          matSortDirection="desc"
          matSortDisableClear
        >
          <!-- Polizzen-Nr. Column -->
          <ng-container matColumnDef="polizzeNummer">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Polizzennummer</th>
            <td mat-cell *matCellDef="let element">
              {{ element.polizzeNummer | formatNumber: 'polizze' }}
            </td>
          </ng-container>

          <!-- Vertragssparte Column -->
          <ng-container matColumnDef="vertragsSparte">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Vertragssparte</th>
            <td mat-cell *matCellDef="let element">
              {{ element.vertragsSparte }}
            </td>
          </ng-container>

          <!-- Kundenname Column -->
          <ng-container matColumnDef="kundeNachname">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Kundenname</th>
            <td mat-cell *matCellDef="let element">{{ element.kundeNachname }} {{ element.kundeVorname }}</td>
          </ng-container>

          <!-- Datum Column -->
          <ng-container matColumnDef="schadenDatum">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Schadendatum</th>
            <td mat-cell *matCellDef="let element">
              {{ element.schadenDatum | amDateFormat: 'DD.MM.YYYY' }}
            </td>
          </ng-container>

          <!-- Schadenvariante Column -->
          <ng-container matColumnDef="schadenVariante">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Schadenvariante</th>
            <td mat-cell *matCellDef="let element">
              {{ element.schadenVariante || '--' }}
            </td>
          </ng-container>

          <!-- letzte Bearbeitung Column NOT DISPLAYED, JUST FOR SORTING-->
          <ng-container matColumnDef="letzteBearbeitungDatum" style="display: none;">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>letzte Bearbeitung</th>
            <td mat-cell *matCellDef="let element">
              {{ element.letzteBearbeitungDatum }}
            </td>
          </ng-container>

          <!-- Aktionen Column -->
          <ng-container matColumnDef="aktionen" stickyEnd>
            <th mat-header-cell *matHeaderCellDef>Aktionen</th>
            <td mat-cell *matCellDef="let element">
              <button mat-icon-button (click)="selectItem($event, element)" matTooltip="Schaden bearbeiten">
                <mat-icon>create</mat-icon>
              </button>
              <button mat-icon-button matTooltip="Im NV Cockpit öffnen" (click)="printItem($event, element)">
                <mat-icon>developer_board</mat-icon>
              </button>
              <button mat-icon-button matTooltip="Entwurf löschen" disabled="{{ isDeleteDisabled }}"
                      (click)="deleteItem($event, element)">
                <mat-icon>delete</mat-icon>
              </button>
            </td>
          </ng-container>

          <!-- IconToggle Column -->
          <ng-container matColumnDef="iconToggle">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let element">
              <button mat-icon-button>
                <mat-icon *ngIf="element !== expandedElement">keyboard_arrow_down</mat-icon>
                <mat-icon *ngIf="element === expandedElement">keyboard_arrow_up</mat-icon>
              </button>
            </td>
          </ng-container>

          <!-- Checklist Detail -->
          <ng-container matColumnDef="checklistDetail">
            <td mat-cell *matCellDef="let element" [attr.colspan]="displayedColumnsEntwurf.length">
              <div class="element-detail" [@detailExpand]="element === expandedElement ? 'expanded' : 'collapsed'">
                <div class="element-description">
                  <div class="element-detail-row" *ngIf="isARGE && isKbma">
                    <div class="element-detail-cell">
                      <p>Betreuernummer:</p>
                    </div>
                    <div class="element-detail-cell">
                      <p>
                        {{ element.betreuerNummer }}
                      </p>
                    </div>
                  </div>

                  <div class="element-detail-row">
                    <div class="element-detail-cell">
                      <p>zuletzt bearbeitet von:</p>
                    </div>
                    <div class="element-detail-cell">
                      <p>{{ element.letzterBearbeiterVorname }} {{ element.letzterBearbeiterNachname }}</p>
                    </div>
                  </div>
                  <div class="element-detail-row">
                    <div class="element-detail-cell">
                      <p>zuletzt bearbeitet am:</p>
                    </div>
                    <div class="element-detail-cell">
                      <p>
                        {{ element.letzteBearbeitungDatum | amDateFormat: 'DD.MM.YYYY' }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumnsEntwurf"></tr>
          <tr
            mat-row
            *matRowDef="let row; columns: displayedColumnsEntwurf"
            class="element-row"
            [class.expanded-row]="expandedElement === row"
            (click)="toggleRowExpand(row)"
          ></tr>
          <tr mat-row *matRowDef="let element; columns: ['checklistDetail']" class="checklist-detail-row"></tr>
        </table>

        <div [hidden]="schadenEntwurfDataSource.data.length <= 0 || entwurfOverviewIsLoading">
          <mat-paginator #paginatorEntwurf [pageSizeOptions]="[10, 50, 100]"></mat-paginator>
        </div>
      </ng-template>
    </mat-tab>
  </mat-tab-group>
</div>
